import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.67 10.25L13.86 9.86999L12 5.40999L10.14 9.86999L5.32999 10.25L8.99999 13.38L7.86999 18.06L12 15.55L16.12 18.06L15 13.38L18.67 10.25ZM11.5804 2.0856C11.6661 2.02848 11.767 1.99864 11.87 1.99999H12.13C12.2319 1.99783 12.3319 2.02749 12.4162 2.08484C12.5004 2.1422 12.5647 2.2244 12.6 2.31999L15.09 8.20999L21.48 8.71999C21.5804 8.72611 21.6765 8.76299 21.7552 8.8256C21.8339 8.88822 21.8914 8.97354 21.92 9.06999L22 9.31999C22.0321 9.41222 22.036 9.51196 22.011 9.6064C21.9861 9.70083 21.9335 9.78566 21.86 9.84999L17 14L18.44 20.22C18.4638 20.3172 18.4585 20.4193 18.4248 20.5136C18.391 20.6078 18.3302 20.6901 18.25 20.75L18.03 20.9C17.9445 20.967 17.8385 21.0023 17.73 21C17.6384 21.0019 17.5482 20.9776 17.47 20.93L12 17.6L6.55999 20.93C6.48178 20.9776 6.39156 21.0019 6.29999 21C6.19144 21.0023 6.08544 20.967 5.99999 20.9L5.74999 20.75C5.66979 20.6901 5.60901 20.6078 5.57523 20.5136C5.54144 20.4193 5.53614 20.3172 5.55999 20.22L6.99999 14L2.14999 9.85999C2.07277 9.79612 2.01699 9.71011 1.99017 9.61355C1.96335 9.51699 1.96677 9.41454 1.99999 9.31999L2.10999 9.06999C2.13854 8.97354 2.19608 8.88822 2.2748 8.8256C2.35352 8.76299 2.44959 8.72611 2.54999 8.71999L8.93999 8.20999L11.39 2.31999C11.4283 2.22443 11.4947 2.14272 11.5804 2.0856Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgStarOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgStarOutline;
